import axios from "axios";
// import commonFunc from '@/tools/common'
import BASE_URL from "../../config/env";
import NetworkInterceptor from '@/plug/request/networkInterceptor'
let requestInterceptor = NetworkInterceptor.requestInterceptor
let requestInterceptorError = NetworkInterceptor.requestInterceptorError
let responseInterceptor = NetworkInterceptor.responseInterceptor
let responseInterceptorError = NetworkInterceptor.responseInterceptorError
import { config } from '@/config/config.js'
// let base = BASE_URL

//创建axios
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
console.log('process.env.BASE_URL', BASE_URL);
const service = axios.create({
  //这里baseurl就是刚开始配置的开发环境和线上环境地址，webpack会自动读取无需手动再改
  // baseURL: BASE_URL, //baseurl
  baseURL: config.baseurl, //baseurl
  timeout: 60000 //请求超时
});

//request拦截
//请求拦截主要作用是验证请求是否合法，会带有用户token，这里模拟一个token，可以根据实际情况修改
service.interceptors.request.use(requestInterceptor, requestInterceptorError);

//respone拦截
//响应拦截主要是对返回做统一处理
service.interceptors.response.use(responseInterceptor, responseInterceptorError);
export default service;
